export default __webpack_public_path__ + "937c9b402b446e830fcf47b5663bfa04.svg";